import React from 'react';
import { genBodyTooltipShiftTemplate } from '../components/UI/ShiftCard/shiftDetails';
import CustomToolTip from '../components/UI/ToolTip/ToolTip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
import _ from 'lodash';

let history = [];
let actions = [];
let t;

export const generateShiftAudit = (shiftAudit, dataviewData, tags, translation, timeOffset = 0, swaps, toCovers, shifts, tagsPartialShift, listEeName, scheduleTagAudits) => {
    t = translation;
    history = [];
    actions = [];
    let auditInfos = {};
    let previousAuditInfos = {};
    // Audit from Kronos
    for (const [index, v2] of shiftAudit.entries()) {
        auditInfos = getAuditInfos(shiftAudit[index - 1], v2, dataviewData, index + 1, listEeName);

        calculShiftDiff(shiftAudit[index - 1], v2, auditInfos, swaps, toCovers, shifts, previousAuditInfos);
        previousAuditInfos = _.clone(auditInfos);
    }

    // Audit from Call list
    auditCallList(shiftAudit, dataviewData, tags, timeOffset, tagsPartialShift, scheduleTagAudits, t);

    history = _.sortBy(history, ['index', 'date', 'time'], ['asc', 'asc', 'asc']);

    return { history, actions };
}

const calculShiftLength = (shift) => {
    return moment.duration(moment(shift.endDateTime, 'YYYY-MM-DD hh:mm:ss').diff(moment(shift.startDateTime, 'YYYY-MM-DD hh:mm:ss')));
}

const auditCallList = (shiftAudit, dataviewData, tags, timeOffset, tagsPartialShift, scheduleTagAudits, t) => {
    for (const tag of tags) {
        if (tag.action !== 'LIS Unavailable' && tag.tagId !== tagsPartialShift.partialAcceptedShift && tag.tagId !== tagsPartialShift.partialShift) {
            let auditTagInfo = {};
            let founded = -1;
            for (const [index, version] of shiftAudit.entries()) {
                if (moment(version.auditTimestamp, 'YYYY-MM-DD hh:mm:ss').isAfter(moment(tag.timestamp))) {
                    founded = index - 1
                    break;
                }
            }

            if (founded === -1) {
                if (moment(tag.timestamp, 'YYYY-MM-DD hh:mm:ss').isSameOrAfter(moment(shiftAudit[shiftAudit.length - 1].auditTimestamp, 'YYYY-MM-DD hh:mm:ss'))) {
                    founded = shiftAudit.length - 1;
                }
            }

            switch (tag.tagId) {
                case tagsPartialShift.partialAcceptedShift:
                case tagsPartialShift.partialShift:
                    break;
                case tagsPartialShift.originalShift:
                    founded = founded - 1;
                    break;
                case tagsPartialShift.acceptedShift:
                default:
                    break;
            }

            if (founded !== -1) {
                let tagVersion = shiftAudit[founded];

                let eeDataviewData = _.find(dataviewData, ['eeId', tag.eeId]);
                eeDataviewData = typeof eeDataviewData !== 'undefined' ? { eeId: tag.eeId, data: eeDataviewData, eeName: eeDataviewData.eeName } : tag.eeId;

                let localTimeStamp = moment(tag.timestamp).add(timeOffset, 'minutes').format("YYYY-MM-DDTHH:mm:ss").replace('T', ' ');

                let eeActionDataviewData = _.find(dataviewData, ['eeId', tag.eeId]);
                let eeName = typeof eeActionDataviewData !== 'undefined' ? eeActionDataviewData.eeName : tag.eeId;

                // let localTimeStampTag;
                // for (const tagAudit of scheduleTagAudits) {
                //     if (tagAudit.scheduleTag.commentNotes && tagAudit.scheduleTag.commentNotes[0].notes && tagAudit.scheduleTag.commentNotes[0].notes[1]) {
                //         if (tag.shiftId === parseInt(tagAudit.scheduleTag.commentNotes[0].notes[1].text, 10)) {
                //             localTimeStampTag = moment(tagAudit.auditTimestamp).add(timeOffset, 'minutes').format("YYYY-MM-DDTHH:mm:ss").replace('T', ' ');
                //             break;
                //         }
                //     }
                // }

                auditTagInfo = {
                    index: founded + 1,
                    auditUser: _.startCase(tag.auditUser),
                    date: localTimeStamp.substring(0, 10),
                    time: localTimeStamp.substring(11, 16),
                    shiftId: genComparedVersionTooltip(tagVersion.shift, founded, founded - 1 >= 0 ? shiftAudit[founded - 1].shift : undefined, tagVersion.shift.id, t),
                    shiftLabel: getShiftLabel(tagVersion.shift),
                    shiftDate: tagVersion.shift.startDateTime.substring(0, 10),
                    shiftStartTime: tagVersion.shift.startDateTime.substring(11, 16),
                    shiftEndTime: tagVersion.shift.endDateTime.substring(11, 16),
                    shiftType: getShiftType(tagVersion.shift),
                    employee: eeDataviewData,
                    segmentsNumber: tagVersion.shift.segments.length,
                    eeId: tag.eeId,
                    source: 'calllist'
                }

                history.push({
                    ...{
                        action: tag.action,
                        source: 'calllist',
                        segmentIndex: '',
                        fieldChanged: '',
                        previousValue: '',
                        notes: tag.CallListNote,
                        eeName: eeName,
                        time: localTimeStamp
                    }, ...auditTagInfo
                });

                actions.push({
                    index: auditTagInfo.index,
                    action: tag.action,
                    source: 'calllist',
                    notes: tag.CallListNote !== '' ? tag.CallListNote : undefined,
                    eeName: eeName,
                    time: localTimeStamp
                });
            }
        }
    }
}

export const getShiftType = (shift) => {
    if (shift.open === true) {
        return 'openshifts';
    }

    if (typeof shift.employee !== 'undefined') {
        return shift.employee.id !== -13 ? 'shifts' : 'openshifts';
    }
}

export const getShiftLabel = (shift) => {
    return (typeof shift.label !== 'undefined' && shift.label !== '') ? shift.label : shift.startDateTime.substring(11, 16) + ' - ' + shift.endDateTime.substring(11, 16)
}

export const hasTransfer = (shift, origine = 'dimensions') => {
    if (origine === 'dimensions') {
        for (const segment of shift.segments) {
            if (segment.segmentType && segment.segmentType.qualifier === 'TRANSFER_SEGMENT') {
                return true;
            }
        }
    } else {
        for (const segment of shift.shiftSegments) {
            if (segment.SegmentTypeName === 'TRANSFER') {
                return true;
            }
        }
    }
    return false;
}

export const getShiftEmploye = (shift) => {
    return (typeof shift.employee !== 'undefined' && shift.employee.id !== -13) ? shift.employee.id : 'Unassigned';
}

const getAuditInfos = (v1 = {}, v2, dataviewData, index, listEeName) => {
    let eeId = getShiftEmploye(v2.shift);
    let eeDataviewData = eeId !== 'Unassigned' ? _.find(dataviewData, ['eeId', eeId]) : 'Unassigned';
    let previousEeId = typeof v1.shift !== 'undefined' ? getShiftEmploye(v1.shift) : '';

    let auditUser = _.find(listEeName, ['userName', v2.auditUser]);

    return {
        index: index,
        auditUser: _.startCase(v2.auditUser),
        auditUserId: auditUser ? auditUser.id : '',
        date: v2.auditLocalTimestamp.substring(0, 10),
        time: v2.auditLocalTimestamp.substring(11, 16),
        shiftId: genComparedVersionTooltip(v2.shift, index, v1.shift, v2.shift.id, t),
        shiftLabel: getShiftLabel(v2.shift),
        shiftDate: v2.shift.startDateTime.substring(0, 10),
        shiftStartTime: v2.shift.startDateTime.substring(11, 16),
        shiftEndTime: v2.shift.endDateTime.substring(11, 16),
        shiftType: getShiftType(v2.shift),
        employee: eeId !== 'Unassigned' ? { eeId: eeId, data: eeDataviewData, eeName: typeof eeDataviewData !== 'undefined' ? eeDataviewData.eeName : eeId } : eeId,
        eeId: eeId !== 'Unassigned' ? eeId : '',
        previousEeId: previousEeId,
        segmentsNumber: v2.shift.segments.length,
        source: 'Schedule'
    }
}

export const genTooltipTitle = (shift) => {
    return <span>
        {((typeof shift.label !== 'undefined' && shift.label !== '') ?
            shift.label :
            shift.startDateTime.substring(11, 16) + ' - ' + shift.endDateTime.substring(11, 16))
            + '  ('
            + _.toLower(moment.duration(moment(shift.endDateTime, 'YYYY-MM-DD hh:mm:ss').diff(moment(shift.startDateTime, 'YYYY-MM-DD hh:mm:ss'))).toString().substring(2)) + ')'}
    </span>
}

const calculShiftDiff = (v1, v2, auditInfos, swaps, toCovers, shifts, previousAuditInfos) => {
    partialShift(v1, v2, auditInfos);
    if (typeof v1 === 'undefined') {
        let action = typeof _.find(v2.shift.relations, ['type', 'FROM_PATTERNITEM_TO_ITEM']) === 'undefined'
            ? (v2.shift.open ? t('ShiftDetails.creationOpen') : t('ShiftDetails.creation'))
            : t('ShiftDetails.creationFromSP');
        let newLine = {
            action: action,
            shiftDate: v2.shift.startDateTime.substring(0, 10),
            shiftLabel: v2.shift.label,
            segmentIndex: '',
            fieldChanged: '',
            previousValue: '',
            newValue: ''
        };

        history.push({ ...newLine, ...auditInfos });
        actions.push({ index: auditInfos.index, action: action, source: 'schedule' });

    } else {
        if (v1.shift.posted !== v2.shift.posted) {
            history.push({
                ...{
                    action: t('ShiftDetails.shift_posted'),
                    shiftDate: v2.shift.startDateTime.substring(0, 10),
                    shiftLabel: v2.shift.label,
                    segmentIndex: '',
                    fieldChanged: '',
                    previousValue: '',
                    newValue: ''
                }, ...auditInfos
            });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.shift_posted'), source: 'schedule' });
        }
        checkShiftNameChange(v1.shift.label, v2.shift.label, auditInfos);
        checkEEchanges(v1, v2, auditInfos, swaps, toCovers, shifts);
        checkDateChange(v1.shift, v2.shift, auditInfos);
        checkRelations(v2.shift, auditInfos);

        if (v1.shift.id !== v2.shift.id) { //if shit ids are different it's a  partial shift from call list
            if (calculShiftLength(v1.shift) !== calculShiftLength(v2.shift)) { // t('ShiftDetails.create_partial_shift')
                if (typeof v2.shift.employee === 'undefined') {
                    history.push({
                        ...{
                            action: t('ShiftDetails.create_partial_shift'),
                            source: 'calllist',
                            segmentIndex: '',
                            fieldChanged: '',
                            previousValue: ''
                        }, ...auditInfos
                    });

                    actions.push({
                        index: auditInfos.index,
                        action: t('ShiftDetails.create_partial_shift'),
                        source: 'calllist',
                        // time: localTimeStamp.substring(11, 16)
                    });
                } else {
                    history.push({
                        ...{
                            action: t('ShiftDetails.partial_shift_accepted'),
                            source: 'calllist',
                            segmentIndex: '',
                            fieldChanged: '',
                            previousValue: ''
                        }, ...auditInfos
                    });
                    actions.push({
                        index: auditInfos.index,
                        action: t('ShiftDetails.partial_shift_accepted'),
                        source: 'calllist'
                    });

                    actions.push({
                        index: auditInfos.index - 1,
                        action: t('ShiftDetails.create_partial_shift'),
                        source: 'calllist'
                    });
                    history.push({
                        ...{
                            action: t('ShiftDetails.create_partial_shift'),
                            source: 'calllist',
                            segmentIndex: '',
                            fieldChanged: '',
                            previousValue: ''
                        }, ...previousAuditInfos
                    });
                }
            }
        } else {
            segmentsChanges(v1.shift.segments, v2.shift.segments, auditInfos);
        }

        commentNotesChanges(v1.shift.commentNotes, v2.shift.commentNotes, auditInfos);
    }
}

const checkDateChange = (v1, v2, auditInfos) => {
    if (v1.startDateTime.substring(0, 10) !== v2.startDateTime.substring(0, 10)) {
        history.push({ ...{ action: t('ShiftDetails.change_startDate'), }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.change_startDate'), source: 'schedule' });
    }

    if (v1.endDateTime.substring(0, 10) !== v2.endDateTime.substring(0, 10)) {
        history.push({ ...{ action: t('ShiftDetails.change_endDate'), }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.change_endDate'), source: 'schedule' });
    }
}

const checkRelations = (v2, auditInfos) => {
    let listRelations = ["FROM_SHIFT_TO_OPEN_SHIFT_REQUEST"];

    for (const relation of listRelations) {
        let founded = _.find(v2.relations, ['type', relation]);

        if (typeof founded !== 'undefined') {
            let newLine = {
                action: t('ShiftDetails.requestOpenshift'),
                shiftDate: v2.startDateTime.substring(0, 10),
                shiftLabel: v2.label
            };

            history.push({ ...newLine, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.requestOpenshift'), source: 'schedule' });

            newLine = {
                action: t('ShiftDetails.assignOpenShift'),
                shiftDate: v2.startDateTime.substring(0, 10),
                shiftLabel: v2.label
            };

            history.push({ ...newLine, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.assignOpenShift'), source: 'schedule' });
        }
    }
}

const checkShiftNameChange = (v1, v2, auditInfos) => {
    if (v1 !== v2) {
        history.push({ ...{ action: t('ShiftDetails.change_shift_label') }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.change_shift_label'), source: 'schedule' });
    }
}

const checkTimeStampsNearlyEgals = (t1, t2, seconds) => {
    return (
        moment(t1).isBetween(
            moment(t2).subtract(seconds, 's'),
            moment(t2).add(seconds, 's'),
            null,
            "[]"
        )
    );
}

const checkEEchanges = (v1, v2, auditInfos, swaps, toCovers, shifts) => {
    if (typeof v1.shift.employee === 'undefined') {
        if (typeof v2.shift.employee !== 'undefined') {
            history.push({ ...{ action: (t('ShiftDetails.assign_ee')) }, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.assign_ee'), source: 'schedule' });
        }
    } else {
        if (typeof v2.shift.employee !== 'undefined' && typeof v1.shift.employee !== 'undefined' && v1.shift.employee.id !== v2.shift.employee.id) {
            let swapRequest;
            if (typeof swaps[v2.shift.id] !== 'undefined') {
                for (const swap of swaps[v2.shift.id]) {
                    for (const statusChanges of swap.requestStatusChanges) {
                        let compareDate = checkTimeStampsNearlyEgals(statusChanges.changeDateTime, v2.auditTimestamp, 1);
                        if (compareDate) {
                            swapRequest = swap;
                        }
                        if (typeof swapRequest !== 'undefined') {
                            break;
                        }
                    }
                    if (typeof swapRequest !== 'undefined') {
                        break;
                    }
                }
            }

            let shiftToCover;
            if (toCovers.length > 0) {
                for (const toCover of toCovers) {
                    for (const statusChanges of toCover.requestStatusChanges) {
                        let compareDate = checkTimeStampsNearlyEgals(statusChanges.changeDateTime, v2.auditTimestamp, 1);
                        if (compareDate) {
                            shiftToCover = toCover;
                        }
                        if (typeof shiftToCover !== 'undefined') {
                            break;
                        }
                    }
                    if (typeof shiftToCover !== 'undefined') {
                        break;
                    }
                }
            }

            if (typeof swapRequest !== 'undefined') {
                let typeSwap = '';
                let labelTypeSwapEE = '';
                if (swapRequest.swapShift.offered.employee.id === v2.shift.employee.id) {
                    typeSwap = t('ShiftDetails.shiftSwapRequested');
                    labelTypeSwapEE = t('ShiftDetails.shiftSwapRequestedBy');
                } else {
                    typeSwap = t('ShiftDetails.shiftSwapOffered');
                    labelTypeSwapEE = t('ShiftDetails.shiftSwapOfferedBy');
                }

                let shiftSwappedId = swapRequest.swapShift.offered.shift.id !== v2.shift.id ? swapRequest.swapShift.offered.shift.id : swapRequest.swapShift.requested[0].shift.id;
                let shiftSwappedEmployee = swapRequest.swapShift.offered.employee.id !== v2.shift.employee.id ? swapRequest.swapShift.offered.employee : swapRequest.swapShift.requested[0].employee;

                let shiftSwapped = _.find(shifts, ['id', shiftSwappedId]);

                history.push({ ...{ action: t('ShiftDetails.shiftSwapRequest'), shiftSwappedId, shiftSwappedEmployee, typeSwap }, ...auditInfos });
                actions.push({
                    index: auditInfos.index,
                    action: t('ShiftDetails.shiftSwapRequest'),
                    shiftSwappedId,
                    shiftSwapped,
                    shiftSwappedEmployee,
                    typeSwap,
                    labelTypeSwapEE,
                    source: 'schedule'
                });
            } if (typeof shiftToCover !== 'undefined') {
                history.push({ ...{ action: t('ShiftDetails.toCover') }, ...auditInfos });
                actions.push({ index: auditInfos.index, action: t('ShiftDetails.toCover'), source: 'schedule' });
            } else {
                if (auditInfos.previousEeId === auditInfos.auditUserId) {
                    history.push({ ...{ action: t('ShiftDetails.requestTimeOff') }, ...auditInfos });
                    actions.push({ index: auditInfos.index, action: t('ShiftDetails.requestTimeOff'), source: 'schedule' });

                    history.push({ ...{ action: t('ShiftDetails.unassign_ee') }, ...auditInfos });
                    actions.push({ index: auditInfos.index, action: t('ShiftDetails.unassign_ee'), source: 'schedule' });
                } else {
                    history.push({ ...{ action: v2.shift.employee.id === -13 ? t('ShiftDetails.unassign_ee') : t('ShiftDetails.change_ee') }, ...auditInfos });
                    actions.push({ index: auditInfos.index, action: v2.shift.employee.id === -13 ? t('ShiftDetails.unassign_ee') : t('ShiftDetails.change_ee'), source: 'schedule' });
                }
            }
        }
    }
}

const commentNotesChanges = (commentNotesV1, commentNotesV2, auditInfos) => {
    if (commentNotesV1.length > commentNotesV2.length) {
        history.push({ ...{ action: t('ShiftDetails.comment_removed') }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.comment_removed'), source: 'schedule' });
    }
    if (commentNotesV1.length < commentNotesV2.length) {
        history.push({ ...{ action: t('ShiftDetails.comment_added') }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.comment_added'), source: 'schedule' });
    }
}

const segmentsChanges = (segmentsV1, segmentsV2, auditInfos) => {
    for (const [index, sV1] of segmentsV1.entries()) {
        let sV2 = _.find(segmentsV2, ['id', sV1.id]);

        if (typeof sV2 !== 'undefined') {
            if (sV2.segmentType.qualifier !== 'BREAK_SEGMENT') {
                let trasferStringV1 = ['', '', '', ''];
                let trasferStringV2 = ['', '', '', ''];

                if (typeof segmentsV1.transferString !== 'undefined') {
                    trasferStringV1 = segmentsV1.transferString.split(';')
                }
                if (typeof segmentsV2.transferString !== 'undefined') {
                    trasferStringV2 = segmentsV2.transferString.split(';')
                }

                segmentCheckTransfer(sV1, sV2, index, 'transferOrgJob', trasferStringV1[0], trasferStringV2[0], auditInfos);
                segmentCheckTransfer(sV1, sV2, index, 'transferCostCenter', trasferStringV1[1], trasferStringV2[1], auditInfos);
                segmentCheckTransfer(sV1, sV2, index, 'transferWorkrule', trasferStringV1[2], trasferStringV2[2], auditInfos);
                for (let i = 3; i < trasferStringV1.length; i++) {
                    if (trasferStringV1[i] !== '') {
                        segmentCheckTransfer(sV1, sV2, index, 'transferLaborCategories', trasferStringV1[i], trasferStringV2[i], auditInfos);
                    }
                }
            }

            segmentCheckTimes(sV1, sV2, index, auditInfos);
        } else {
            history.push({ ...{ action: t('ShiftDetails.segment_removed'), segmentIndex: index + 1 }, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.segment_removed'), segmentIndex: index + 1, source: 'schedule' });
        }
    }
    segmentCheckNew(segmentsV1, segmentsV2, auditInfos);
}

const getSegmentType = (segment) => {
    let segmentType = '';
    switch (segment.segmentType.qualifier) {
        case "REGULAR_SEGMENT":
            segmentType = 'Regular';
            break;
        case "TRANSFER_SEGMENT":
            segmentType = 'Transfer';
            break;
        default:
            break;
    }
    return segmentType;
}

const segmentCheckNew = (segmentsV1, segmentsV2, auditInfos) => {
    for (const [index, sV2] of segmentsV2.entries()) {
        let sV1 = _.find(segmentsV1, ['id', sV2.id]);

        if (typeof sV1 === 'undefined') {
            history.push({ ...{ action: t('ShiftDetails.segment_added'), segmentIndex: index + 1 }, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.segment_added'), segmentIndex: index + 1, source: 'schedule' });
        }
    }
}

const segmentCheckTransfer = (sV1, sV2, index, type, transferV1, transferV2, auditInfos) => {
    if (sV1[type] !== sV2[type]) {
        if (sV2[type]) {
            history.push({ ...{ action: t('ShiftDetails.add_transfer_' + type), segmentIndex: index + 1, orgPath: transferV2, segmentType: getSegmentType(sV2) }, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.add_transfer_' + type), segmentIndex: index + 1, source: 'schedule' });
        } else {
            history.push({ ...{ action: t('ShiftDetails.remove_transfer_' + type), segmentIndex: index + 1, orgPath: transferV2, segmentType: getSegmentType(sV2) }, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.remove_transfer_' + type), segmentIndex: index + 1, source: 'schedule' });
        }
    } else {
        if (transferV1 !== transferV2) {
            history.push({ ...{ action: t('ShiftDetails.change_transfer_' + type), segmentIndex: index + 1, orgPath: transferV2, segmentType: getSegmentType(sV2) }, ...auditInfos });
            actions.push({ index: auditInfos.index, action: t('ShiftDetails.change_transfer_' + type), segmentIndex: index + 1, source: 'schedule' });
        }
    }
}

const segmentCheckTimes = (sV1, sV2, index, auditInfos) => {
    if (sV1.startDateTime.substring(11, 16) !== sV2.startDateTime.substring(11, 16)) {
        history.push({ ...{ action: t('ShiftDetails.change_startTime'), segmentIndex: index + 1, segmentType: getSegmentType(sV2) }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.change_startTime'), segmentIndex: index + 1, source: 'schedule' });
    }
    if (sV1.endDateTime.substring(11, 16) !== sV2.endDateTime.substring(11, 16)) {
        history.push({ ...{ action: t('ShiftDetails.change_endTime'), segmentIndex: index + 1, segmentType: getSegmentType(sV2) }, ...auditInfos });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.change_endTime'), segmentIndex: index + 1, source: 'schedule' });
    }
}

const partialShift = (v1, v2, auditInfos) => {
    if (typeof v1 !== 'undefined' && v2.index < v1.index) {
        actions.push({ index: auditInfos.index - 1, action: t('ShiftDetails.partial_shift_delete_original'), source: 'calllist' });
        actions.push({ index: auditInfos.index, action: t('ShiftDetails.partial_shift'), source: 'schedule' });
    }
}

const genComparedVersionTooltip = (version, indexVersion, previousVersion, id, t) => {
    return (
        <CustomToolTip
            style={{ width: '100%' }}
            enterDelay={1000}
            titletext={
                <div style={{ display: 'flex' }}>
                    {
                        typeof previousVersion !== 'undefined' ?
                            <React.Fragment>
                                <div style={{ paddingRight: '15px', border: '1px solid lightgray', padding: '3px 10px', borderRadius: '5px 5px 5px 5px' }}>
                                    <div style={{ paddingBottom: '15px' }}>
                                        <span style={{ fontWeight: 'bold' }}>{'Version ' + (indexVersion - 1)}
                                        </span>
                                    </div>
                                    {genBodyTooltipShiftTemplate(previousVersion, t)}
                                </div>
                                {
                                    previousVersion.id === version.id ?
                                        <span style={{ fontWeight: 'bold', fontSize: 'xx-large', color: 'lightgray', paddingTop: '40px' }}>&#10230;</span> :
                                        <span style={{ fontWeight: 'bold', fontSize: 'xx-large', color: 'lightgray', paddingTop: '40px' }}>&#x21dd;</span>
                                }
                            </React.Fragment> :
                            ''
                    }
                    <div style={{ border: '1px solid lightgray', padding: '3px 10px', borderRadius: '5px 5px 5px 5px' }}>
                        <div style={{ paddingBottom: '15px' }}>
                            <span style={{ fontWeight: 'bold' }}>{'Version ' + indexVersion}
                            </span>
                        </div>
                        {genBodyTooltipShiftTemplate(version, t)}
                    </div>
                </div>
            }
            jsx={<span>{id}</span>}
        />
    )
}

export const genTooltipTitleLabel = (shift) => {
    if (typeof shift === 'undefined') {
        return <></>
    }
    const transferIcon = hasTransfer(shift)
        ? <FontAwesomeIcon style={{ marginLeft: '10px', marginRight: '10px' }} icon={faExchangeAlt} />
        : <></>;

    if (shift.label !== null && shift.label !== '') {
        return (<span>{shift.label}  {transferIcon}</span>)
    }

    const shiftLabel = `${shift.startDateTime.substring(11, 16)} - ${shift.endDateTime.substring(11, 16)}`;
    const shiftDuration = _.toLower(moment.duration(moment(shift.endDateTime, 'YYYY-MM-DD hh:mm:ss').diff(moment(shift.startDateTime, 'YYYY-MM-DD hh:mm:ss'))).toString().substring(2));
    const shiftDurationLabel = `(${shiftDuration})`;

    return (<span>{shiftLabel} {transferIcon} {shiftDurationLabel}</span>)
}

export const calculShiftDuration = (shift) => {
    return _.round(moment.duration(moment(shift.endDateTime.substring(0, 10) + shift.endDateTime.substring(11, 20), 'YYYY-MM-DDhh:mm:ss')
        .diff(moment(shift.startDateTime.substring(0, 10) + shift.startDateTime.substring(11, 20), 'YYYY-MM-DDhh:mm:ss')))
        .as('hours'), 2).toFixed(2);
}

export const shiftsGetEmployees = (shifts) => {
    let eeIds = [];
    for (const shift of shifts) {
        if (shift.employee) {
            eeIds.push(shift.employee.id);
        }
    }
    return eeIds;
}

export const shiftsAuditGetEmployees = (audits) => {
    return audits.map(audit => {
        if (audit.shift.employee) {
            return audit.shift.employee.id;
        } else {
            return undefined;
        }
    });
}